// src/auth.js

// 1) Core Firebase SDK
import { initializeApp } from "firebase/app";

// 2) Auth SDK
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged 
} from "firebase/auth";

// 3) Firestore & Storage SDKs
import { getFirestore } from "firebase/firestore";
import { getStorage }   from "firebase/storage";

// 4) Analytics SDK
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDTVj3zT11gv_Rb1iwAY0aSFmxwLdF0u_s",
  authDomain: "editvibe-90968.firebaseapp.com",
  projectId: "editvibe-90968",
  storageBucket: "editvibe-90968.firebasestorage.app",
  messagingSenderId: "377851515440",
  appId: "1:377851515440:web:7cfe243c90110e44cc13f5",
  measurementId: "G-25JKKXFV1G"      // ← your Google Analytics measurement ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Initialize Authentication, Firestore, and Storage
export const auth     = getAuth(app);
export const db       = getFirestore(app);
export const storage  = getStorage(app);

// Set up Google authentication provider
const provider = new GoogleAuthProvider();

// Function to sign in with Google
export const signInWithGoogle = () => {
  signInWithPopup(auth, provider)
    .then((result) => {
      console.log("Signed in with Google");
    })
    .catch((error) => {
      console.error("Error signing in with Google", error);
    });
};

// Function to log out
export const logout = () => {
  signOut(auth)
    .then(() => {
      console.log("User logged out");
    })
    .catch((error) => {
      console.error("Error logging out", error);
    });
};

// Listen for auth state changes and log user details
onAuthStateChanged(auth, (user) => {
  if (user) {
    console.log("User is logged in:", user);
  } else {
    console.log("No user is logged in");
  }
});